import { Icon } from "@mindlercare/ui-web";
import { defaultTheme } from "@mindlercare/ui-web/src/shared/constants";
import { Progress } from "api/types";
import { ProgramTreatmentCellText } from "components/patients/patientCard/icbt/tablecells/ProgramTreatmentCellText";
import { StatusInProgressCell } from "components/patients/patientCard/icbt/tablecells/StatusCompletedCell";
import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import { ProgramsAndTreatments } from "../../../hooks/icbt/useGetAllProgramsAndTreatmentsQuery";
import { Typography } from "../../typography";

interface Props {
  program?: ProgramsAndTreatments["programs"][0];
  treatment?: ProgramsAndTreatments["treatments"][0];
  progress?: Progress;
}

const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  & svg {
    flex-shrink: 0;
  }
`;

export const ProgramItem = ({ program, treatment, progress }: Props) => {
  const { t } = useTranslation();
  return (
    <ItemWrapper>
      {progress?.completedAt ? (
        <Icon.CheckCircle width={20} color={defaultTheme.COLORS.GRAY} />
      ) : (
        <Icon.Assignment width={20} color={defaultTheme.COLORS.GRAY} />
      )}

      {program && treatment ? (
        <ProgramTreatmentCellText
          programName={program.title}
          treatmentName={treatment.title}
        >
          {(() => {
            if (!progress) return null;
            if (!progress.completedAt)
              return (
                <StatusInProgressCell
                  percentage={
                    !progress.totalPages // if totalPages, default to 0%
                      ? 0
                      : ((progress.maxProgressedPageIndex + 1) /
                          progress.totalPages) *
                        100
                  }
                />
              );
          })()}
        </ProgramTreatmentCellText>
      ) : (
        <ProgramNotAvailable variant="body" insensitive>
          {t("PROGRAM_WAS_REMOVED")}
        </ProgramNotAvailable>
      )}
    </ItemWrapper>
  );
};

const ProgramNotAvailable = styled(Typography)`
  color: ${({ theme }) => theme.COLORS.ERROR};
`;
